/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum GraphQLContentStatus {
  ARCHIVED = "ARCHIVED",
  CURRENT = "CURRENT",
  DELETED = "DELETED",
  DRAFT = "DRAFT",
}

export interface ContentSpecificCreateInput {
  key: string;
  value: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================

/* tslint:disable */
/* eslint-disable */
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL mutation operation: CreateSmartLinkEmbedMutation
// ====================================================

export interface CreateSmartLinkEmbedMutation_createContentContextual_space {
  id: string | null;
  key: string | null;
  alias: string | null;
}

export interface CreateSmartLinkEmbedMutation_createContentContextual {
  id: string | null;
  space: CreateSmartLinkEmbedMutation_createContentContextual_space | null;
}

export interface CreateSmartLinkEmbedMutation {
  createContentContextual: CreateSmartLinkEmbedMutation_createContentContextual;
}

export interface CreateSmartLinkEmbedMutationVariables {
  contentSpecificCreateInput?: ContentSpecificCreateInput[] | null;
  parentId?: string | null;
  spaceKey?: string | null;
  title?: string | null;
  type: string;
  status: GraphQLContentStatus;
}
